var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import 'isomorphic-fetch';
import RouletteClient from './RouletteClient';
import { Provider } from './RouletteContext';
var RouletteProvider = /** @class */ (function (_super) {
    __extends(RouletteProvider, _super);
    function RouletteProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            variables: props.variables || null
        };
        return _this;
    }
    RouletteProvider.prototype.componentDidMount = function () {
        var _this = this;
        if (!window.roulette) {
            window.roulette = new RouletteClient(this.props.endpoint);
        }
        if (!this.props.variables && this.props.userID) {
            window.roulette.get(this.props.userID)
                .then(function (variables) { return _this.setState({ variables: variables }); });
        }
    };
    RouletteProvider.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!this.props.variables && this.props.userID && this.props.userID != prevProps.userID) {
            window.roulette.get(this.props.userID)
                .then(function (variables) { return _this.setState({ variables: variables }); });
        }
    };
    RouletteProvider.prototype.render = function () {
        return (React.createElement(Provider, { value: this.state.variables }, this.state.variables ? this.props.children : this.props.fallback));
    };
    RouletteProvider.defaultProps = {
        fallback: false
    };
    return RouletteProvider;
}(React.Component));
export default RouletteProvider;
//# sourceMappingURL=RouletteProvider.js.map